import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

import { css } from '@emotion/core'
import React from 'react'
import Slider from 'react-slick'

import { breakpoints } from '../constants/breakPoints'
import SvgIcon from './SvgIcon'

interface Props {
  heading?: string
  arrowColor?: 'black' | 'white'
  settings?: any
  children: any[]
}
const defaultSettings = {
  infinite: true,
  speed: 500,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  slidesPerRow: 1,
  prevArrow: (
    <SvgIcon
      src="abstract/corousel-left-arrow"
      css={css`
        margin-right: 0.5rem;
        bottom: 0;
        right: 2rem;
        left: initial;
        top: 110%;
        width: 2rem;
        height: 2rem;
        &:hover {
          opacity: 0.65;
        }
      `}
    />
  ),
  nextArrow: (
    <SvgIcon
      src="abstract/corousel-right-arrow"
      css={css`
        top: 110%;
        right: 0;
        width: 2rem;
        height: 2rem;
        &:hover {
          opacity: 0.65;
        }
      `}
    />
  ),
}

export const AutoCarousel: React.FunctionComponent<Props> = ({ heading, arrowColor = 'white', settings, children }) => {
  return (
    <React.Fragment>
      {heading && (
        <h3 className="heading3" css={headingStyle}>
          {heading}
        </h3>
      )}
      <div css={containerStyle(children.length, arrowColor)}>
        <Slider {...defaultSettings} {...settings}>
          {children.map((child) => (
            <div key={child.key}>{child}</div>
          ))}
        </Slider>
      </div>
    </React.Fragment>
  )
}

const headingStyle = css`
  margin-bottom: 2rem;
`

const containerStyle = (length: number, color: string) => css`
  text-align: center;

  .slick-arrow {
    circle,
    path {
      stroke: ${color};
    }
  }

  .slick-slide {
    box-sizing: border-box;
    padding: 0 3px;

    @media screen and (min-width: ${breakpoints.large + 1}px) {
      ${length < 4 &&
      ` padding: 0 10px !important;
        width: max-content !important;
      `}
    }

    @media screen and (min-width: ${breakpoints.medium + 1}px) {
      ${length < 3 &&
      ` padding: 0 10px !important;
        width: max-content !important;
      `}
    }
  }
`
